import BubbleService from "../BubbleService";

class SchoolService extends BubbleService {
    topSchools = ['Đại học Quản lý và Công nghệ TP. HCM'];

    constructor() {
        super();
    }

    getSchoolList = async () => {
        const data1: any = await this.getObj("School");
        const data2: any = await this.getObj("School?cursor=100");
        const data3: any = await this.getObj("School?cursor=200");
        const data = [...data1.results, ...data2.results, ...data3.results];
        return data;
    };

    getSchoolByType = (type: any, schools: any[]) => {
        if (type && schools.length > 0) {
            let list: any = []

            schools.forEach(item => {
                if (type == item.Type && item.Status == true) {
                    if (this.topSchools.includes(item.Name)) {
                        list = [{value: item.Name, label: item.Name, isSpecial: true}, ...list]
                    } else {
                        list = [...list, {value: item.Name, label: item.Name, isSpecial: false}]
                    }
                }
            });

            return list
        }
        return []
    }

    getTypeBySchool = (school: string, schools: any[]) => {
        const result = schools.find(item => {
            return item.Name === school;
        })
        return result.Type
    }

    getDefaultSchoolOption = (school: string, schools: any[]) => {
        const result = schools.find(item => {
            return item.name === school;
        })
        return {value: result.name, label: result.name}
    }
}

export default SchoolService;
